<div class="login-page">
  <div class="login-brand">
    <div class="logo-icon">
      <mat-icon>business</mat-icon>
    </div>
    <div>
      <strong>Trusted Technologies</strong>
      <p>HR &amp; Enterprise Platform</p>
    </div>
  </div>

  <mat-card class="login-card">
    <h1>Sign in</h1>
    <p class="subtitle">Use your organization credentials to continue.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="username" />
        <mat-icon matPrefix>mail</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hidePassword() ? 'password' : 'text'"
          formControlName="password"
          autocomplete="current-password" />
        <mat-icon matPrefix>lock</mat-icon>
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword.set(!hidePassword())"
          [attr.aria-label]="'Toggle password visibility'">
          <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tenant slug</mat-label>
        <input matInput formControlName="tenantSlug" placeholder="acme" />
        <mat-icon matPrefix>domain</mat-icon>
      </mat-form-field>

      @if (error()) {
        <div class="error-banner">{{ error() }}</div>
      }

      <button
        mat-raised-button
        color="primary"
        class="full-width submit-btn"
        type="submit"
        [disabled]="loading() || form.invalid">
        @if (loading()) {
          <mat-spinner diameter="22"></mat-spinner>
        } @else {
          Sign in
        }
      </button>
    </form>

    <div class="auth-links">
      <a routerLink="/register">Create account</a>
      <a routerLink="/forgot-password">Forgot password?</a>
    </div>

    <div class="demo-hint">
      <strong>Demo account</strong>
      <span>admin&#64;acme.local / Password123!</span>
      <span>tenantSlug: acme</span>
      <button mat-stroked-button type="button" (click)="fillDemo()">Fill demo credentials</button>
    </div>
  </mat-card>
</div>
